import axios from "axios";

const ApiChat = axios.create({
  baseURL: process.env.REACT_APP_MS_CHAT_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

const ApiChatFeedback = axios.create({
  baseURL:
    process.env.REACT_APP_MS_CHAT_URL_FEED || process.env.REACT_APP_MS_CHAT_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export { ApiChatFeedback };
export default ApiChat;